import { render, staticRenderFns } from "./default-action-input.vue?vue&type=template&id=572c579f&scoped=true"
import script from "./default-action-input.vue?vue&type=script&lang=js"
export * from "./default-action-input.vue?vue&type=script&lang=js"
import style0 from "./default-action-input.vue?vue&type=style&index=0&id=572c579f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c579f",
  null
  
)

export default component.exports